import { CoverageChange } from '@zorro/clients';
import { useRoles } from '@zorro/web/ui-utils';

import { PlanBadge } from '../PlanBadge';

type Props = {
  coverageChange?: CoverageChange | null;
};

export const RenewalBadge = ({ coverageChange }: Props) => {
  const { isEmployeeOnlyRole } = useRoles();
  if (coverageChange !== CoverageChange.RENEWAL) {
    return null;
  }

  return (
    <PlanBadge
      tooltipLabel={
        isEmployeeOnlyRole
          ? 'This plan was renewed from your previous coverage'
          : "Renewed from the employee's previous coverage period"
      }
      label="Renewal"
      size="sm"
    />
  );
};
